import React from 'react';
import { Link } from 'react-router-dom'
import { connect } from 'react-redux';
import { mobileCheckinColorConfig } from '../../JS/colorConfig'
import { getDefaultAnalyticsLabel } from '../../JS/utility';
import { sendAnalytics } from '../../../action/homeAction';
import { setGoHome } from '../../action/homeAction';
import ico_status_fail from "./assets/ico_status_fail.svg";
import ico_status_success from "./assets/ico_status_pass.svg";
import ico_success from "./assets/ico_success.svg"
import ico_error from "./assets/ico_error.svg"
import { CMSPath } from '../../../config/constant';
import { withTranslation } from 'react-i18next';

class Result extends React.Component {

  constructor(props){
    super(props);
  }

  componentDidUpdate(){
    mobileCheckinColorConfig(this.props.menuColor);
  }


  componentDidMount() {
    window.scrollTo(0,0);
    mobileCheckinColorConfig(this.props.menuColor);

    const failureMessage = `${!this.props.success && !this.props.message ? "Something went wrong" : this.props.message }`
    // Send Analytics
    let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})

    if(!this.props.success && this.props.page == "confidance"){
      
      this.props.sendAnalytics(
          null, // as no guesdetails in logout state 
          this.props.currentWidgetObj.widgetType || "Mobile Check-in", 
          "VERIFYING YOUR IDENTITY - FAILED",
          {...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget", "pageName": "VERIFYING YOUR IDENTITY", "widgetSessionId": localStorage.getItem("checkinSessionToken"), "errorMessage": this.props.ga_error_message}, 
          0, 
          false // guest is not logged in
      );
    }

  }

  render() {
    const failureMessage = `${!this.props.success && !this.props.message ? "Something went wrong" : this.props.message }`
    const sucessMessage = "Please wait while we save your information and page will redirect you to the next step"
    const {t} = this.props


    return (
      <div className="main-container">
        <header className="inner-pages w-footer subpages">
          {/* {!this.props.backBtn ? <a href="javascript:window.history.back(-1);" className="button-back"></a>
          :  */}
          <a onClick={this.props.backBtn} className="button-back"></a>
          <div className="heading align-center">
            <div class="splash-brand">
                  <img src={`${CMSPath}${this.props.logo}`} />
              </div>
            {/* <p className="bold" style = {{color:"inherit"}}>{this.props.currentWidgetObj.widgetType == "Pre Check-in" ? t('pre_checkIn.preCheckIn_heading') : t('check_in.guest_checkin')}</p> */}
          </div>
        </header>
        <section className="widgets padding-0 margin-0 container-bg errorresult">

          <div class="widget-header widget-header-checkin-inner result">
              { this.props.currentWidgetObj.widgetHeaderImageUrl && 
                  <div class="widget-header-img">
                      <img src={`${CMSPath}${this.props.currentWidgetObj.widgetHeaderImageUrl}`} alt={this.props.currentWidgetObj.displayName} />
                  </div>
              }

              {
                process.env.REACT_APP_NEWER_DESIGN=="true" ?
                <>
                  <div class="widget-header-title">{this.props.heading}</div>
                  <div class="widget-header-subtitle">{this.props.subheading}</div>
                </>
                :
                <div class="widget-header-title">{this.props.currentWidgetObj.widgetType == "Pre Check-in" ? t('pre_checkIn.preCheckIn_heading') : t('check_in.guest_checkin')}</div>
              }
              
          </div>

          <div className="widgets">
            <div className="row padding-top-1 padding-bottom-0 padding-right-1 padding-left-1">
              <h2 className = "all-caps">{(this.props.success ? 'Success' : 'Oops')}</h2>
            </div>
            <div className="form-window">
              <div className="form-window-heading">
                Details
              </div>
              <div className="row padding-top-1 padding-bottom-1 padding-right-1 padding-left-1">
                <div className="form-row">
                  <p>{this.props.success ? sucessMessage :  failureMessage}</p>
                </div>
                <div className="form-row">
                  <div className= {`progress-circle ${this.props.success ? 'success' :  'error' } over50 p100`}>
                    <span>
                      {
                        this.props.success ? <img src={ico_success} alt="" />// <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 333.33 237.59"><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path className="cls-1" d="M328.32,5h0a17.13,17.13,0,0,0-24.21,0l-191.5,191.5L29.22,113.13a17.13,17.13,0,0,0-24.21,0H5a17.13,17.13,0,0,0,0,24.21l95.25,95.25a17.74,17.74,0,0,0,24.69,0L328.32,29.22A17.13,17.13,0,0,0,328.32,5Z"/></g></g></svg>  
                        : <img src={ico_error} alt="" />//<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 237.6 237.6"><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path class="cls-1" d="M143,118.8l89.58-89.58a17.13,17.13,0,0,0,0-24.21h0a17.13,17.13,0,0,0-24.21,0L118.8,94.59,29.22,5A17.12,17.12,0,0,0,5,29.22L94.59,118.8,5,208.38a17.13,17.13,0,0,0,0,24.21H5a17.13,17.13,0,0,0,24.21,0L118.8,143l89.58,89.58a17.13,17.13,0,0,0,24.21,0h0a17.13,17.13,0,0,0,0-24.21Z"/></g></g></svg>
                      }
                    </span>
                    <div className="left-half-clipper">
                      <div className="first50-bar"></div>
                      <div className="value-bar"></div>
                    </div>
                  </div>
                </div>
                <div className="form-row margin-top-2 margin-bottom-2">
                  <p>{(this.props.cardChecksData.guestValidationMaxRetry <= 0) ? "Please contact Front Desk" : this.props.success ? "If page does not redirect to the next step click here to proceed" :  "What would you like to do?"}</p>
                </div>
                <div className="form-controls">
                  { (this.props.cardChecksData.guestValidationMaxRetry <= 0) ?  null : <>
                  {!this.props.backBtn ? <Link  exact to={this.props.success ? '/checkin/confidence/verified/booking' : '/checkin/idCapture'}>
                    <button className="primary w-100">
                      {this.props.success ? "Procced to booking information" : "Try Again"}
                    </button> 
                  </Link>
                  : <button className="primary w-100" onClick={this.props.tryAgain ? this.props.tryAgain : this.props.backBtn}>
                    {this.props.success ? "Procced to booking information" : "Try Again"}
                  </button>}
                  </>}
                  <button className="secondary w-100 margin-top-1" onClick = {() => {this.props.setGoHome(true)}}>Close</button>
                  
                </div>
              </div>
            </div>
            
          </div>
        </section>
    </div>
    )
  }
}

const mapStateToProps = state => {
  return {
      menuColor: state.store.home.MenuColor,
      logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
      currentWidgetObj: state.store.sideNavBar.currentWidget,
      guestIsLoggedIn: state.store2.guestIsLoggedIn,
      installedAppVersion: state.store.installedAppVersion,
      installedAppBuildNo: state.store.installedAppBuildNo,
      currentHomePage: state.store2.currentHomePage,
      cardChecksData: state.store2.cardChecksData,
  }
}

export default connect(mapStateToProps, {sendAnalytics, setGoHome})(withTranslation('translations')(Result));